import { AddCircleOutlined, Edit, InsertLink } from "@material-ui/icons";
import { Button } from "@mui/material";
import moment from "moment";
import { copyToClipboard } from "./CommonFunctions";
import styles from "./styles/Utils.module.scss";

export const applicationDbColumns = (
  data,
  DownloadDocuments,
  applicationStatusList,
  handleUserModal,
  classes,
  userAction,
  IndeterminateCheckbox
) => {
  const list = [
    {
      Header: "Lead ID",
      accessor: "leadId",
    },
    {
      Header: "Name",
      accessor: "name",
    },
    {
      Header: "Phone Number",
      accessor: "phoneNumber",
    },
    {
      Header: "Email",
      accessor: "gmailId",
    },
    {
      Header: "Perm. Address",
      accessor: "address",
      Cell: (row) => {
        return <div style={{ width: "250px" }}>{row.row.original.address}</div>;
      },
    },
    {
      Header: "City",
      accessor: "city",
    },
    {
      Header: "Gender",
      accessor: "gender",
    },
    {
      Header: "DOB",
      accessor: "dateOfBirth",
      Cell: (row) => {
        return (
          <div style={{ width: "min-content" }}>
            {row.row.original.dateOfBirth
              ? moment(row.row.original.dateOfBirth).format("DD/MM/YYYY")
              : ""}
          </div>
        );
      },
    },
    {
      Header: "Preferred Pincodes",
      accessor: "preferredPincodes",
      Cell: (row) => {
        return (
          <div style={{ width: "250px", overflowWrap: "break-word" }}>
            {row.row.original?.preferredPincodes?.split(",").join(", ")}
          </div>
        );
      },
    },
    {
      Header: "Languages",
      accessor: "languages",
      Cell: (row) => {
        return (
          <div style={{ width: "250px", overflowWrap: "break-word" }}>
            {row.row.original?.languages?.split(",").join(", ")}
          </div>
        );
      },
    },
    {
      Header: "Assets",
      accessor: "assests",
      Cell: (row) => {
        return (
          <div style={{ width: "250px", overflowWrap: "break-word" }}>
            {row.row.original?.assests?.split(",").join(", ")}
          </div>
        );
      },
    },
    {
      Header: "Qualifications",
      accessor: "qualification",
    },
    {
      Header: "Source",
      accessor: "source",
    },
    {
      Header: "MPA Name",
      accessor: "mpaName",
    },
    {
      Header: "Status",
      accessor: "applicationStatus",
      Cell: (row) => {
        return (
          <div>
            {row.row.original.applicationStatus
              ? applicationStatusList[
                  Object.keys(applicationStatusList).find(
                    (statusKey) =>
                      statusKey == row.row.original.applicationStatus
                  )
                ]
              : "-"}
          </div>
        );
      },
    },
    {
      Header: "Applied On",
      accessor: "appliedOn",
      Cell: (row) => {
        return (
          <div style={{ width: "min-content" }}>
            {row.row.original.appliedOn
              ? moment(row.row.original.appliedOn).format("DD/MM/YYYY hh:mm A")
              : "-"}
          </div>
        );
      },
    },
    {
      Header: "Status Updated On",
      accessor: "updatedOn",
      Cell: (row) => {
        return (
          <div style={{ width: "min-content" }}>
            {row.row.original.updatedOn
              ? moment(row.row.original.updatedOn).format("DD/MM/YYYY hh:mm A")
              : "-"}
          </div>
        );
      },
    },
    {
      Header: "Assigned To",
      accessor: "recruiterAssigned",
      Cell: (row) => {
        const assignedTo = row.row.original.recruiterAssigned
          ? "rec"
          : row.row.original.opsAssignedName
          ? "ops"
          : "";
        const assignedName =
          assignedTo === "rec"
            ? row.row.original.recruiterAssigned
            : assignedTo === "ops"
            ? row.row.original.opsAssignedName
            : "";
        const assignedNumber =
          assignedTo === "rec"
            ? row.row.original.recruiterAssignedNumber || ""
            : "";
        const assignedOn =
          assignedTo === "rec"
            ? row.row.original.recruiterAssignedOn
            : assignedTo === "ops"
            ? row.row.original.opsAssignedOn
            : "";

        return (
          <div>
            <div>
              {assignedName
                ? `${assignedName}${
                    assignedNumber ? ` - ` + assignedNumber : ""
                  }${assignedTo ? ` (${assignedTo})` : ""}`
                : "-"}
            </div>
            <div>
              {assignedOn ? moment(assignedOn).format("DD/MM/YYYY") : "-"}
            </div>
          </div>
        );
      },
    },
    {
      Header: "Documents",
      accessor: "docAvailable",
      Cell: DownloadDocuments,
    },
    {
      Header: "Remarks",
      accessor: "remarks",
      Cell: (row) => {
        return (
          <div style={{ width: "250px" }}>
            {row.row.original.remarks ? (
              <div style={{ display: "flex" }}>
                <span>{row.row.original.remarks}</span>
                <button
                  className={styles.remarkIcon}
                  onClick={(e) =>
                    handleUserModal(e, row.row.original, "remark")
                  }
                  style={{ marginLeft: "10px", padding: "0" }}
                >
                  <Edit />
                </button>
              </div>
            ) : (
              <Button
                className={`${classes.remarkButton} blueColorOutlined`}
                onClick={(e) => handleUserModal(e, row.row.original, "remark")}
              >
                <AddCircleOutlined />
                Add Remark
              </Button>
            )}
          </div>
        );
      },
    },
  ];

  if (!!userAction.edit) {
    list.unshift({
      id: "selection",
      Header: ({ getToggleAllRowsSelectedProps }) => (
        <div>
          <IndeterminateCheckbox
            {...getToggleAllRowsSelectedProps()}
            className="overrideCheckbox"
            color="default"
            style={{ color: "#fff" }}
          />
        </div>
      ),
      Cell: ({ row }) => (
        <div id="check1">
          <IndeterminateCheckbox
            {...row.getToggleRowSelectedProps()}
            style={{ display: "flex", justifyItems: "center" }}
          />
        </div>
      ),
    });
  }
  return list;
};

const InvoiceLinkCell = (row, downloadTemplateClass) =>
  row.row.original.invoiceFilePath ? (
    <a href={row.row.original.invoiceFilePath} download className={downloadTemplateClass}>
      <span style={{ color: "#1c4980" }}>{row.row.original.billNo}</span>
    </a>
  ) : (
    <span></span>
  );

const SelectionColumn = (IndeterminateCheckbox, mainFilterOption) => ({
  id: "selection",
  Header: ({ getToggleAllRowsSelectedProps }) => (
    <div>
      <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} className="overrideCheckbox" color="white"/>
    </div>
  ),
  Cell: ({ row }) => (
    <>
      {(mainFilterOption === 1 || mainFilterOption === 8) && localStorage.getItem("roleType") === "6" ? (
        <div>
          {row.original.invoiceFilePath !== "" && (
            <div>
              <IndeterminateCheckbox
                {...row.getToggleRowSelectedProps()}
                style={row.original.invoiceFilePath === "" ? {} : { display: "flex", justifyItems: "center" }}
                disabled={row.original.invoiceFilePath === ""}
              />
            </div>
          )}
        </div>
      ) : (
        <div>
          <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} style={{ display: "flex", justifyItems: "center" }} />
        </div>
      )}
    </>
  ),
});

export const paymentListingColumns = (tab, { IndeterminateCheckbox, mainFilterOption, downloadTemplateClass }) => {
  if (!tab.invoiceTab && tab.workerDataTab) {
    return [
      SelectionColumn(IndeterminateCheckbox, mainFilterOption),
      { Header: "Project Name", accessor: "projectName", defaultCanFilter: false, defaultCanSort: false },
      { Header: "OkayGo id", accessor: "okaygoId", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Client", accessor: "source", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Invoice Status", accessor: "payment_stage", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Name", accessor: "name", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Phone Number", accessor: "contactNo", defaultCanFilter: false, defaultCanSort: false },
      { Header: "PAN No", accessor: "panNumber", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Bank Details filled", accessor: "bankDetailsFilled", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Bank details verification", accessor: "pennyStatus", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Bill From", accessor: "InvoiceFrom", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Bill To", accessor: "InvoiceTo", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Invoice Date", accessor: "billDate", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Invoice No", accessor: "billNo", Cell: (row) => InvoiceLinkCell(row, downloadTemplateClass), defaultCanFilter: false, defaultCanSort: false },
      { Header: "Tasks Done/Shipment Delivered", accessor: "shipmentQuantity", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Base Pay", accessor: "shipmentAmount", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Total Addition", accessor: "bonus", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Net Payable Amount", accessor: "netPayableAmount", defaultCanFilter: false, defaultCanSort: false },
      { Header: "TDS Deduction", accessor: "tdsDeduction", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Total Deductions", accessor: "adjustments", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Remark", accessor: "remark", defaultCanFilter: false, defaultCanSort: false },
      { Header: "OkayGo Payout (uploaded)", accessor: "og_payout", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Margin Value", accessor: "og_margin", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Margin %", accessor: "marginPercent", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Payment Status", accessor: "paymentStatus", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Failed/Reversed Reason", accessor: "razorpayReason", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Payment Date", accessor: "paymentDate", defaultCanFilter: false, defaultCanSort: false },
    ];
  }

  if (!tab.invoiceTab && tab.recruiterDataTab) {
    return [
      SelectionColumn(IndeterminateCheckbox, mainFilterOption),
      { Header: "Recruiter ID", accessor: "okaygoId", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Client", accessor: "source", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Invoice Status", accessor: "payment_stage", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Remark", accessor: "remark", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Name", accessor: "name", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Contact No", accessor: "contactNo", defaultCanFilter: false, defaultCanSort: false },
      { Header: "PAN No", accessor: "panNumber", defaultCanFilter: false, defaultCanSort: false },
      { Header: "PAN Verification Status", accessor: "panVerification", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Bank Details filled", accessor: "bankDetailsFilled", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Bank Details Verification", accessor: "pennyStatus", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Invoice Cycle (from)", accessor: "billFrom", defaultCanFilter: false, defaultCanSort: false, isVisible: true },
      { Header: "Invoice Cycle (to)", accessor: "billTo", defaultCanFilter: false, defaultCanSort: false, isVisible: false },
      { Header: "Invoice No", accessor: "billNo", Cell: (row) => InvoiceLinkCell(row, downloadTemplateClass), defaultCanFilter: false, defaultCanSort: false },
      { Header: "Service Charges", accessor: "shipmentAmount", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Surge Charges (incentives etc.)", accessor: "surgeCharges", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Deductions (TDS etc.)", accessor: "tdsAdjustments", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Net Payable Amount", accessor: "totalAmount", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Payment Date", accessor: "paymentDate", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Payment Status", accessor: "paymentStatus", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Failed/Reversed Reason", accessor: "razorpayReason", defaultCanFilter: false, defaultCanSort: false },
    ];
  }

  if (tab.recruiterDataTab && !tab.transactionTab) {
    return [
      { Header: "Recruiter ID", accessor: "okaygoId", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Name", accessor: "name", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Contact No", accessor: "contactNo", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Invoice No", accessor: "billNo", Cell: (row) => InvoiceLinkCell(row, downloadTemplateClass), defaultCanFilter: false, defaultCanSort: false },
      { Header: "Invoice Cycle (from)", accessor: "billFrom", defaultCanFilter: false, defaultCanSort: false, isVisible: true },
      { Header: "Invoice Cycle (to)", accessor: "billTo", defaultCanFilter: false, defaultCanSort: false, isVisible: false },
      { Header: "Transaction Date", accessor: "paymentDate", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Total Amount", accessor: "totalAmount", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Transaction Status", accessor: "paymentStatus", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Transaction Mode", accessor: "paymentMode", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Transaction Remarks", accessor: "paymentRemarks", defaultCanFilter: false, defaultCanSort: false },
      { Header: "Transaction ID", accessor: "transactionNo", defaultCanFilter: false, defaultCanSort: false },
    ];
  }

  // transactionCols (default)
  return [
    {
      Header: "Client id",
      accessor: "casperId",
      defaultCanFilter: false,
      defaultCanSort: false,
      Cell: (row) =>
        row.row.original.casperId ? (
          <div>
            <b>{row.row.original.source ? row.row.original.source + " : " : ""}</b>&nbsp;{row.row.original.casperId}
          </div>
        ) : (
          <span></span>
        ),
    },
    { Header: "OkayGo id", accessor: "okaygoId", defaultCanFilter: false, defaultCanSort: false },
    { Header: "Name", accessor: "name", defaultCanFilter: false, defaultCanSort: false },
    { Header: "Contact No", accessor: "contactNo", defaultCanFilter: false, defaultCanSort: false },
    { Header: "Invoice No", accessor: "billNo", Cell: (row) => InvoiceLinkCell(row, downloadTemplateClass), defaultCanFilter: false, defaultCanSort: false },
    { Header: "Bill From", accessor: "billFrom", defaultCanFilter: false, defaultCanSort: false, isVisible: true },
    { Header: "Bill To", accessor: "billTo", defaultCanFilter: false, defaultCanSort: false, isVisible: false },
    { Header: "Okaygo Charges", accessor: "okaygoCharges", defaultCanFilter: false, defaultCanSort: false, isVisible: false },
    { Header: "Paid Amount", accessor: "totalAmount", defaultCanFilter: false, defaultCanSort: false },
    { Header: "Payment Type", accessor: "paymentType", defaultCanFilter: false, defaultCanSort: false },
    { Header: "Transaction Date", accessor: "paymentDate", defaultCanFilter: false, defaultCanSort: false },
    { Header: "Transaction Status", accessor: "paymentStatus", defaultCanFilter: false, defaultCanSort: false },
    { Header: "Transaction Mode", accessor: "paymentMode", defaultCanFilter: false, defaultCanSort: false },
    { Header: "Transaction Remarks", accessor: "paymentRemarks", defaultCanFilter: false, defaultCanSort: false },
    { Header: "Transaction ID", accessor: "transactionNo", defaultCanFilter: false, defaultCanSort: false },
  ];
};

export const mpaDetailColumns = (data) => {
  const list = [
    {
      Header: "Job Name",
      accessor: "job_name",
      Cell: (row) => {
        return (
          <div style={{ width: "319px" }}>
            {row.row.original.job_name || ""}
          </div>
        );
      },
    },
    {
      Header: "Total Applicants",
      accessor: "totalAppliedWorker",
    },
    {
      Header: "Total Workers",
      accessor: "totalReadyToWork",
    },
    {
      Header: "Job Link",
      accessor: "jobLink",
      Cell: (row) => {
        return row.row.original.jobLink ? (
          <Button
            className="flexDisplay blueButtonOutlined2 fontSize16"
            onClick={() => copyToClipboard(row.row.original.jobLink)}
          >
            <InsertLink
              style={{
                rotate: "135deg",
                color: "#1C4980",
              }}
            />
            Copy Link
          </Button>
        ) : (
          "-"
        );
      },
    },
  ];
  return list;
};

export const historyModalColumns = (getStatusLabel, getStatusStyle, Styles) => [
  {
    Header: "Lead Name",
    accessor: "name",
    Cell: ({ value }) => <p>{value}</p>,
  },
  {
    Header: "Phone Number",
    accessor: "phoneNumber",
    Cell: ({ value }) => <p>{value}</p>,
  },
  {
    Header: "Current Status",
    accessor: "callStatus",
    Cell: ({ value }) => {
      const label = getStatusLabel(value);
      return (
        <span
          className={`${Styles.historyStatusBadge} ${getStatusStyle(label)}`}
        >
          {label}
        </span>
      );
    },
  },
  {
    Header: "Called On",
    accessor: "calledOnDate",
    Cell: ({ value }) => (
      <p>{value ? new Date(value).toLocaleDateString("en-IN") : "-"}</p>
    ),
  },
  {
    Header: "Call Attempts",
    accessor: "callAttempts",
    Cell: ({ value }) => <p>{value >= 5 ? "5+" : value}</p>,
  },
];

export const recruitmentDashboardColumns = () => {
  const list = [
    {
      Header: "Name",
      accessor: "name",
      defaultCanFilter: false,
      defaultCanSort: false,
    },
    {
      Header: "Phone Number",
      accessor: "phoneNumber",
      defaultCanFilter: false,
      defaultCanSort: false,
    },
    {
      Header: "Calling Date",
      accessor: "calledOnDate",
      defaultCanFilter: false,
      defaultCanSort: false,
    },
    {
      Header: "Call Attempts",
      accessor: "callAttempts",
      defaultCanFilter: false,
      defaultCanSort: false,
    },
  ];
  return list;
};
